export default __webpack_public_path__ + "static/02-01-writing-responses-3335acbc9c58105e32070a82efbb213d.mp4";